export interface LocationData {
  slug: string;
  city: string;
  state: string;
  region?: string;
  metaTitle: string;
  metaDescription: string;
  content: string;
  neighbors: { label: string; href: string }[];
}

const locations: LocationData[] = [
  {
    slug: "louisville-ky", city: "Louisville", state: "KY", region: "Kentucky",
    metaTitle: "Electrician Louisville KY | Hadley",
    metaDescription: "Commercial & industrial electrical contractor in Louisville, KY. HVAC, energy management, lighting. Same-day service. (502) 921-3777.",
    content: "As Louisville's locally-owned electrical contractor since 2013, Hadley Energy Solutions serves the entire Jefferson County area including downtown Louisville, the Highlands, St. Matthews, Jeffersontown, Shively, and the industrial corridors along Dixie Highway and Preston Highway. We've completed major projects at Freedom Hall, the Kentucky International Convention Center, and Churchill Downs.",
    neighbors: [{ label: "Jeffersontown, KY", href: "/service-area/jeffersontown-ky" }, { label: "St. Matthews, KY", href: "/service-area/st-matthews-ky" }, { label: "Shepherdsville, KY", href: "/service-area/shepherdsville-ky" }, { label: "New Albany, IN", href: "/service-area/new-albany-in" }],
  },
  {
    slug: "elizabethtown-ky", city: "Elizabethtown", state: "KY", region: "Kentucky",
    metaTitle: "Certified Electrician Elizabethtown KY | Panel Upgrades",
    metaDescription: "Certified electrician in Elizabethtown, KY for electrical panel upgrades, commercial wiring, industrial electrical & HVAC. Free estimates. (502) 921-3777.",
    content: "Hadley Energy Solutions is a certified electrician serving Elizabethtown and the greater Hardin County area with commercial and industrial electrical services, including electrical panel upgrades in Elizabethtown KY for homes, businesses, and industrial facilities. Located just 45 minutes south of our Louisville headquarters, E-town's growing industrial sector and the military-connected economy at Fort Knox make it an important part of our service territory. Whether you need a certified electrician in Elizabethtown KY for an electrical panel upgrade, a service call, or a full industrial project, our licensed crews (CE64623 | ME64500) are dispatched to Hardin County daily. We've completed projects at the Hardin County Water Treatment Plant and several manufacturing facilities along Ring Road.",
    neighbors: [{ label: "Louisville, KY", href: "/service-area/louisville-ky" }, { label: "Bardstown, KY", href: "/service-area/bardstown-ky" }, { label: "Shepherdsville, KY", href: "/service-area/shepherdsville-ky" }, { label: "Radcliff, KY", href: "/service-area/radcliff-ky" }, { label: "Fort Knox, KY", href: "/service-area/fort-knox-ky" }],
  },
  {
    slug: "lexington-ky", city: "Lexington", state: "KY", region: "Kentucky",
    metaTitle: "Electrical & HVAC Service Area: Lexington, KY",
    metaDescription: "Top-rated electrician in Lexington, KY. Commercial, industrial and residential electrical work. Licensed CE64623. Call (502) 921-3777.",
    content: "Hadley Energy Solutions is a trusted electrician in Lexington, KY serving the entire Fayette County area — from downtown Lexington and the University of Kentucky campus to Hamburg, Beaumont, Tates Creek, and the industrial corridor along Newtown Pike. As Kentucky's second-largest city, Lexington's thriving business community, university campuses, equine industry, and growing technology sector demand reliable electrical, HVAC, and energy management services from a licensed contractor.",
    neighbors: [{ label: "Louisville, KY", href: "/service-area/louisville-ky" }, { label: "Frankfort, KY", href: "/service-area/frankfort-ky" }, { label: "Georgetown, KY", href: "/service-area/georgetown-ky" }, { label: "Nicholasville, KY", href: "/service-area/nicholasville-ky" }, { label: "Richmond, KY", href: "/service-area/richmond-ky" }],
  },
];

/** Geographic neighbor map — every location gets 4+ contextually relevant links */
const neighborMap: Record<string, { label: string; href: string }[]> = {
  "shepherdsville-ky": [
    { label: "Louisville, KY", href: "/service-area/louisville-ky" },
    { label: "Hillview, KY", href: "/service-area/hillview-ky" },
    { label: "Mt. Washington, KY", href: "/service-area/mt-washington-ky" },
    { label: "Elizabethtown, KY", href: "/service-area/elizabethtown-ky" },
    { label: "Bardstown, KY", href: "/service-area/bardstown-ky" },
  ],
  "mt-washington-ky": [
    { label: "Louisville, KY", href: "/service-area/louisville-ky" },
    { label: "Shepherdsville, KY", href: "/service-area/shepherdsville-ky" },
    { label: "Hillview, KY", href: "/service-area/hillview-ky" },
    { label: "Jeffersontown, KY", href: "/service-area/jeffersontown-ky" },
    { label: "Simpsonville, KY", href: "/service-area/simpsonville-ky" },
  ],
  "hillview-ky": [
    { label: "Louisville, KY", href: "/service-area/louisville-ky" },
    { label: "Shepherdsville, KY", href: "/service-area/shepherdsville-ky" },
    { label: "Mt. Washington, KY", href: "/service-area/mt-washington-ky" },
    { label: "Elizabethtown, KY", href: "/service-area/elizabethtown-ky" },
  ],
  "jeffersontown-ky": [
    { label: "Louisville, KY", href: "/service-area/louisville-ky" },
    { label: "St. Matthews, KY", href: "/service-area/st-matthews-ky" },
    { label: "Mt. Washington, KY", href: "/service-area/mt-washington-ky" },
    { label: "Simpsonville, KY", href: "/service-area/simpsonville-ky" },
    { label: "Shelbyville, KY", href: "/service-area/shelbyville-ky" },
  ],
  "st-matthews-ky": [
    { label: "Louisville, KY", href: "/service-area/louisville-ky" },
    { label: "Jeffersontown, KY", href: "/service-area/jeffersontown-ky" },
    { label: "La Grange, KY", href: "/service-area/la-grange-ky" },
    { label: "Shelbyville, KY", href: "/service-area/shelbyville-ky" },
  ],
  "la-grange-ky": [
    { label: "Louisville, KY", href: "/service-area/louisville-ky" },
    { label: "St. Matthews, KY", href: "/service-area/st-matthews-ky" },
    { label: "Shelbyville, KY", href: "/service-area/shelbyville-ky" },
    { label: "Frankfort, KY", href: "/service-area/frankfort-ky" },
  ],
  "simpsonville-ky": [
    { label: "Louisville, KY", href: "/service-area/louisville-ky" },
    { label: "Shelbyville, KY", href: "/service-area/shelbyville-ky" },
    { label: "Jeffersontown, KY", href: "/service-area/jeffersontown-ky" },
    { label: "Frankfort, KY", href: "/service-area/frankfort-ky" },
  ],
  "bardstown-ky": [
    { label: "Cox's Creek, KY", href: "/service-area/coxs-creek-ky" },
    { label: "Shepherdsville, KY", href: "/service-area/shepherdsville-ky" },
    { label: "Elizabethtown, KY", href: "/service-area/elizabethtown-ky" },
    { label: "Danville, KY", href: "/service-area/danville-ky" },
    { label: "Louisville, KY", href: "/service-area/louisville-ky" },
  ],
  "coxs-creek-ky": [
    { label: "Bardstown, KY", href: "/service-area/bardstown-ky" },
    { label: "Shepherdsville, KY", href: "/service-area/shepherdsville-ky" },
    { label: "Louisville, KY", href: "/service-area/louisville-ky" },
    { label: "Elizabethtown, KY", href: "/service-area/elizabethtown-ky" },
  ],
  "frankfort-ky": [
    { label: "Lexington, KY", href: "/service-area/lexington-ky" },
    { label: "Georgetown, KY", href: "/service-area/georgetown-ky" },
    { label: "Shelbyville, KY", href: "/service-area/shelbyville-ky" },
    { label: "La Grange, KY", href: "/service-area/la-grange-ky" },
    { label: "Louisville, KY", href: "/service-area/louisville-ky" },
  ],
  "shelbyville-ky": [
    { label: "Louisville, KY", href: "/service-area/louisville-ky" },
    { label: "Simpsonville, KY", href: "/service-area/simpsonville-ky" },
    { label: "Frankfort, KY", href: "/service-area/frankfort-ky" },
    { label: "La Grange, KY", href: "/service-area/la-grange-ky" },
    { label: "Jeffersontown, KY", href: "/service-area/jeffersontown-ky" },
  ],
  "radcliff-ky": [
    { label: "Fort Knox, KY", href: "/service-area/fort-knox-ky" },
    { label: "Elizabethtown, KY", href: "/service-area/elizabethtown-ky" },
    { label: "Shepherdsville, KY", href: "/service-area/shepherdsville-ky" },
    { label: "Bardstown, KY", href: "/service-area/bardstown-ky" },
  ],
  "fort-knox-ky": [
    { label: "Radcliff, KY", href: "/service-area/radcliff-ky" },
    { label: "Elizabethtown, KY", href: "/service-area/elizabethtown-ky" },
    { label: "Shepherdsville, KY", href: "/service-area/shepherdsville-ky" },
    { label: "Louisville, KY", href: "/service-area/louisville-ky" },
  ],
  "georgetown-ky": [
    { label: "Lexington, KY", href: "/service-area/lexington-ky" },
    { label: "Frankfort, KY", href: "/service-area/frankfort-ky" },
    { label: "Nicholasville, KY", href: "/service-area/nicholasville-ky" },
    { label: "Richmond, KY", href: "/service-area/richmond-ky" },
  ],
  "richmond-ky": [
    { label: "Lexington, KY", href: "/service-area/lexington-ky" },
    { label: "Nicholasville, KY", href: "/service-area/nicholasville-ky" },
    { label: "Danville, KY", href: "/service-area/danville-ky" },
    { label: "Georgetown, KY", href: "/service-area/georgetown-ky" },
  ],
  "nicholasville-ky": [
    { label: "Lexington, KY", href: "/service-area/lexington-ky" },
    { label: "Richmond, KY", href: "/service-area/richmond-ky" },
    { label: "Danville, KY", href: "/service-area/danville-ky" },
    { label: "Georgetown, KY", href: "/service-area/georgetown-ky" },
  ],
  "danville-ky": [
    { label: "Nicholasville, KY", href: "/service-area/nicholasville-ky" },
    { label: "Lexington, KY", href: "/service-area/lexington-ky" },
    { label: "Richmond, KY", href: "/service-area/richmond-ky" },
    { label: "Bardstown, KY", href: "/service-area/bardstown-ky" },
  ],
  "bowling-green-ky": [
    { label: "Elizabethtown, KY", href: "/service-area/elizabethtown-ky" },
    { label: "Owensboro, KY", href: "/service-area/owensboro-ky" },
    { label: "Louisville, KY", href: "/service-area/louisville-ky" },
    { label: "Bardstown, KY", href: "/service-area/bardstown-ky" },
  ],
  "owensboro-ky": [
    { label: "Bowling Green, KY", href: "/service-area/bowling-green-ky" },
    { label: "Elizabethtown, KY", href: "/service-area/elizabethtown-ky" },
    { label: "Louisville, KY", href: "/service-area/louisville-ky" },
    { label: "Florence, KY", href: "/service-area/florence-ky" },
  ],
  "florence-ky": [
    { label: "Covington, KY", href: "/service-area/covington-ky" },
    { label: "Erlanger, KY", href: "/service-area/erlanger-ky" },
    { label: "Independence, KY", href: "/service-area/independence-ky" },
    { label: "Burlington, KY", href: "/service-area/burlington-ky" },
    { label: "Newport, KY", href: "/service-area/newport-ky" },
  ],
  "covington-ky": [
    { label: "Newport, KY", href: "/service-area/newport-ky" },
    { label: "Florence, KY", href: "/service-area/florence-ky" },
    { label: "Erlanger, KY", href: "/service-area/erlanger-ky" },
    { label: "Independence, KY", href: "/service-area/independence-ky" },
  ],
  "newport-ky": [
    { label: "Covington, KY", href: "/service-area/covington-ky" },
    { label: "Florence, KY", href: "/service-area/florence-ky" },
    { label: "Erlanger, KY", href: "/service-area/erlanger-ky" },
    { label: "Burlington, KY", href: "/service-area/burlington-ky" },
  ],
  "independence-ky": [
    { label: "Florence, KY", href: "/service-area/florence-ky" },
    { label: "Covington, KY", href: "/service-area/covington-ky" },
    { label: "Burlington, KY", href: "/service-area/burlington-ky" },
    { label: "Erlanger, KY", href: "/service-area/erlanger-ky" },
  ],
  "erlanger-ky": [
    { label: "Florence, KY", href: "/service-area/florence-ky" },
    { label: "Covington, KY", href: "/service-area/covington-ky" },
    { label: "Independence, KY", href: "/service-area/independence-ky" },
    { label: "Burlington, KY", href: "/service-area/burlington-ky" },
  ],
  "burlington-ky": [
    { label: "Florence, KY", href: "/service-area/florence-ky" },
    { label: "Independence, KY", href: "/service-area/independence-ky" },
    { label: "Erlanger, KY", href: "/service-area/erlanger-ky" },
    { label: "Covington, KY", href: "/service-area/covington-ky" },
  ],
  "new-albany-in": [
    { label: "Louisville, KY", href: "/service-area/louisville-ky" },
    { label: "Jeffersonville, IN", href: "/service-area/jeffersonville-in" },
    { label: "Clarksville, IN", href: "/service-area/clarksville-in" },
    { label: "Charlestown, IN", href: "/service-area/charlestown-in" },
    { label: "Sellersburg, IN", href: "/service-area/sellersburg-in" },
  ],
  "jeffersonville-in": [
    { label: "Louisville, KY", href: "/service-area/louisville-ky" },
    { label: "New Albany, IN", href: "/service-area/new-albany-in" },
    { label: "Clarksville, IN", href: "/service-area/clarksville-in" },
    { label: "Sellersburg, IN", href: "/service-area/sellersburg-in" },
    { label: "Charlestown, IN", href: "/service-area/charlestown-in" },
  ],
  "clarksville-in": [
    { label: "Jeffersonville, IN", href: "/service-area/jeffersonville-in" },
    { label: "New Albany, IN", href: "/service-area/new-albany-in" },
    { label: "Sellersburg, IN", href: "/service-area/sellersburg-in" },
    { label: "Louisville, KY", href: "/service-area/louisville-ky" },
  ],
  "charlestown-in": [
    { label: "Jeffersonville, IN", href: "/service-area/jeffersonville-in" },
    { label: "Sellersburg, IN", href: "/service-area/sellersburg-in" },
    { label: "New Albany, IN", href: "/service-area/new-albany-in" },
    { label: "Louisville, KY", href: "/service-area/louisville-ky" },
  ],
  "sellersburg-in": [
    { label: "Jeffersonville, IN", href: "/service-area/jeffersonville-in" },
    { label: "Charlestown, IN", href: "/service-area/charlestown-in" },
    { label: "Clarksville, IN", href: "/service-area/clarksville-in" },
    { label: "Louisville, KY", href: "/service-area/louisville-ky" },
  ],
  "salem-in": [
    { label: "New Albany, IN", href: "/service-area/new-albany-in" },
    { label: "Charlestown, IN", href: "/service-area/charlestown-in" },
    { label: "Madison, IN", href: "/service-area/madison-in" },
    { label: "Louisville, KY", href: "/service-area/louisville-ky" },
  ],
  "madison-in": [
    { label: "Salem, IN", href: "/service-area/salem-in" },
    { label: "New Albany, IN", href: "/service-area/new-albany-in" },
    { label: "Charlestown, IN", href: "/service-area/charlestown-in" },
    { label: "Louisville, KY", href: "/service-area/louisville-ky" },
  ],
};

const simpleLocations: { slug: string; city: string; state: string; region: string }[] = [
  // Kentucky
  { slug: "shepherdsville-ky", city: "Shepherdsville", state: "KY", region: "Kentucky" },
  { slug: "mt-washington-ky", city: "Mt. Washington", state: "KY", region: "Kentucky" },
  { slug: "hillview-ky", city: "Hillview", state: "KY", region: "Kentucky" },
  { slug: "jeffersontown-ky", city: "Jeffersontown", state: "KY", region: "Kentucky" },
  { slug: "st-matthews-ky", city: "St. Matthews", state: "KY", region: "Kentucky" },
  { slug: "la-grange-ky", city: "La Grange", state: "KY", region: "Kentucky" },
  { slug: "simpsonville-ky", city: "Simpsonville", state: "KY", region: "Kentucky" },
  { slug: "bardstown-ky", city: "Bardstown", state: "KY", region: "Kentucky" },
  { slug: "coxs-creek-ky", city: "Cox's Creek", state: "KY", region: "Kentucky" },
  { slug: "frankfort-ky", city: "Frankfort", state: "KY", region: "Kentucky" },
  { slug: "shelbyville-ky", city: "Shelbyville", state: "KY", region: "Kentucky" },
  { slug: "radcliff-ky", city: "Radcliff", state: "KY", region: "Kentucky" },
  { slug: "fort-knox-ky", city: "Fort Knox", state: "KY", region: "Kentucky" },
  { slug: "georgetown-ky", city: "Georgetown", state: "KY", region: "Kentucky" },
  { slug: "richmond-ky", city: "Richmond", state: "KY", region: "Kentucky" },
  { slug: "nicholasville-ky", city: "Nicholasville", state: "KY", region: "Kentucky" },
  { slug: "danville-ky", city: "Danville", state: "KY", region: "Kentucky" },
  { slug: "bowling-green-ky", city: "Bowling Green", state: "KY", region: "Kentucky" },
  { slug: "owensboro-ky", city: "Owensboro", state: "KY", region: "Kentucky" },
  { slug: "florence-ky", city: "Florence", state: "KY", region: "Northern Kentucky" },
  { slug: "covington-ky", city: "Covington", state: "KY", region: "Northern Kentucky" },
  { slug: "newport-ky", city: "Newport", state: "KY", region: "Northern Kentucky" },
  { slug: "independence-ky", city: "Independence", state: "KY", region: "Northern Kentucky" },
  { slug: "erlanger-ky", city: "Erlanger", state: "KY", region: "Northern Kentucky" },
  { slug: "burlington-ky", city: "Burlington", state: "KY", region: "Northern Kentucky" },
  // Southern Indiana
  { slug: "new-albany-in", city: "New Albany", state: "IN", region: "Southern Indiana" },
  { slug: "jeffersonville-in", city: "Jeffersonville", state: "IN", region: "Southern Indiana" },
  { slug: "clarksville-in", city: "Clarksville", state: "IN", region: "Southern Indiana" },
  { slug: "charlestown-in", city: "Charlestown", state: "IN", region: "Southern Indiana" },
  { slug: "sellersburg-in", city: "Sellersburg", state: "IN", region: "Southern Indiana" },
  { slug: "salem-in", city: "Salem", state: "IN", region: "Southern Indiana" },
  { slug: "madison-in", city: "Madison", state: "IN", region: "Southern Indiana" },
];

/** Per-city unique copy fragments to eliminate duplicate title/description/content audits */
const cityDetail: Record<string, { tag: string; landmark: string; focus: string }> = {
  "shepherdsville-ky": { tag: "Bullitt County's industrial hub", landmark: "the UPS Worldport corridor and I-65 distribution centers", focus: "warehouse lighting, MCC installations, and 24/7 emergency electrical service" },
  "mt-washington-ky": { tag: "fast-growing Bullitt County suburb", landmark: "Highway 44 retail corridor and local schools", focus: "commercial build-outs, generator installation, and rooftop HVAC replacements" },
  "hillview-ky": { tag: "a Bullitt County community we serve daily", landmark: "Old Preston Highway and the Hillview business district", focus: "panel upgrades, lighting retrofits, and design-build electrical projects" },
  "jeffersontown-ky": { tag: "the Bluegrass Commerce Park area", landmark: "Bluegrass Industrial Park and Taylorsville Road employers", focus: "industrial controls, fire alarm systems, and commercial HVAC service" },
  "st-matthews-ky": { tag: "Louisville's premier east-end retail district", landmark: "Mall St. Matthews, Shelbyville Road Plaza, and Frankfort Avenue", focus: "tenant build-outs, restaurant electrical, and refrigeration service" },
  "la-grange-ky": { tag: "Oldham County's historic downtown", landmark: "Main Street rail corridor and Oldham County schools", focus: "school electrical work, downtown lighting, and small-business HVAC" },
  "simpsonville-ky": { tag: "the Outlet Shoppes of the Bluegrass region", landmark: "I-64 outlet shopping district and Shelby County warehouses", focus: "retail electrical, parking-lot lighting, and rooftop unit installations" },
  "bardstown-ky": { tag: "Kentucky's Bourbon Capital in Nelson County", landmark: "the Kentucky Bourbon Trail distilleries and downtown Bardstown", focus: "distillery electrical, hazardous-location wiring, and process cooling" },
  "coxs-creek-ky": { tag: "rural Nelson County along US-31E", landmark: "Bluegrass Parkway access and the surrounding farms and distilleries", focus: "agricultural electrical, generator installation, and shop wiring" },
  "frankfort-ky": { tag: "Kentucky's state capital in Franklin County", landmark: "the Capitol complex and downtown government district", focus: "government facility electrical, switchgear, and building automation" },
  "shelbyville-ky": { tag: "Shelby County's historic county seat", landmark: "Main Street, Saddlebred Country, and the I-64 logistics corridor", focus: "agricultural electrical, equine-facility lighting, and warehouse HVAC" },
  "radcliff-ky": { tag: "the gateway community next to Fort Knox", landmark: "Wilson Road, Dixie Highway, and the Fort Knox base perimeter", focus: "military-adjacent commercial electrical, retail HVAC, and surge protection" },
  "fort-knox-ky": { tag: "the Fort Knox military installation area", landmark: "the U.S. Bullion Depository area and Hardin County government buildings", focus: "secure facility electrical, mission-critical generators, and high-voltage service" },
  "georgetown-ky": { tag: "Scott County and Toyota Motor Manufacturing Kentucky", landmark: "the Toyota plant, Cherry Blossom industrial park, and downtown Georgetown", focus: "automotive plant electrical, MCCs, and PLC controls" },
  "richmond-ky": { tag: "Madison County and Eastern Kentucky University", landmark: "the EKU campus, Battlefield Memorial Highway, and Bluegrass Army Depot", focus: "university electrical, large-scale HVAC, and lighting retrofits" },
  "nicholasville-ky": { tag: "Jessamine County just south of Lexington", landmark: "Brannon Crossing, Main Street, and the I-75 commerce belt", focus: "generator installation in Nicholasville, retail electrical, fire alarm systems, and HVAC service" },
  "danville-ky": { tag: "Boyle County and historic Centre College", landmark: "Centre College, Constitution Square, and the Heart of Danville district", focus: "campus electrical, downtown rewiring projects, and energy audits" },
  "bowling-green-ky": { tag: "Warren County and the WKU region", landmark: "the Corvette Assembly Plant, WKU campus, and I-65 industrial corridor", focus: "manufacturing electrical, large-scale lighting retrofits, and ESCO projects" },
  "owensboro-ky": { tag: "Daviess County along the Ohio River", landmark: "downtown Owensboro, the riverfront convention center, and US-60 industry", focus: "riverfront commercial electrical, marine-grade wiring, and commercial HVAC" },
  "florence-ky": { tag: "Boone County in the Greater Cincinnati area", landmark: "Florence Mall, the Mall Road retail district, and CVG airport access", focus: "retail electrical, hospitality HVAC, and commercial generators" },
  "covington-ky": { tag: "Northern Kentucky's urban core on the Ohio River", landmark: "MainStrasse Village, the Roebling Bridge, and the Madison Avenue corridor", focus: "historic-building electrical, hospitality HVAC, and high-rise lighting" },
  "newport-ky": { tag: "Campbell County across from downtown Cincinnati", landmark: "Newport on the Levee, the Aquarium district, and Monmouth Street", focus: "entertainment-district electrical, restaurant refrigeration, and HVAC service" },
  "independence-ky": { tag: "Kenton County's largest city", landmark: "Madison Pike, the Independence Town Square, and surrounding subdivisions", focus: "commercial build-out wiring, panel upgrades, and HVAC installations" },
  "erlanger-ky": { tag: "Kenton County near CVG airport", landmark: "Dixie Highway, the CVG cargo corridor, and Crescent Springs employers", focus: "logistics electrical, warehouse lighting, and rooftop HVAC service" },
  "burlington-ky": { tag: "Boone County's historic county seat", landmark: "the Boone County Courthouse and the rapidly growing US-42 corridor", focus: "government facility electrical, school HVAC, and generator installation" },
  "new-albany-in": { tag: "Floyd County across the Ohio River from Louisville", landmark: "downtown New Albany, the Sherman Minton Bridge, and State Street", focus: "historic-building rewiring, restaurant electrical, and commercial HVAC" },
  "jeffersonville-in": { tag: "Clark County along the Ohio River waterfront", landmark: "the Big Four Bridge, Jeffersonville's NoCo arts district, and the I-65 corridor", focus: "riverfront commercial electrical, hospitality HVAC, and lighting retrofits" },
  "clarksville-in": { tag: "Clark County's commercial retail hub", landmark: "Veterans Parkway, the Falls of the Ohio, and the Greentree Mall area", focus: "retail electrical, sign and parking-lot lighting, and rooftop HVAC" },
  "charlestown-in": { tag: "northern Clark County and the River Ridge corridor", landmark: "the River Ridge Commerce Center and Charlestown State Park", focus: "industrial park electrical, MCC programming, and commercial HVAC installations" },
  "sellersburg-in": { tag: "Clark County along the I-65 distribution corridor", landmark: "Ivy Tech Sellersburg and the US-31 industrial parks", focus: "warehouse electrical, dock lighting, and industrial ventilation" },
  "salem-in": { tag: "Washington County in southern Indiana", landmark: "the Washington County Courthouse and SR-56 commercial district", focus: "small-town commercial electrical, generator installation, and HVAC service" },
  "madison-in": { tag: "Jefferson County along the historic Ohio River", landmark: "downtown Madison's National Historic District and the Madison riverfront", focus: "historic-property electrical, restaurant HVAC, and lighting upgrades" },
};

/**
 * Keep a templated city description inside the SERP limit measured on the
 * SERVED (HTML-escaped) markup — an apostrophe costs 6 characters there.
 * Drops whole clauses from the end rather than cutting mid-word.
 */
function fitDescription(text: string, max = 155) {
  const rendered = (s: string) => s.replace(/&/g, "&amp;").replace(/'/g, "&#x27;").length;
  if (rendered(text) <= max) return text;
  const parts = text.split(". ").filter(Boolean);
  while (parts.length > 1 && rendered(parts.join(". ")) > max) parts.splice(parts.length - 2, 1);
  let out = parts.join(". ");
  while (rendered(out) > max) {
    const next = out.replace(/\s+\S+\.?$/, "").replace(/[,;—-]$/, "") + ".";
    if (next === out) break;
    out = next;
  }
  return out;

}

const expandedDescriptionSlugs = new Set([
  "la-grange-ky",
  "bowling-green-ky",
  "shepherdsville-ky",
  "clarksville-in",
  "frankfort-ky",
  "bardstown-ky",
  "jeffersontown-ky",
  "mt-washington-ky",
  "shelbyville-ky",
  "nicholasville-ky",
  "richmond-ky",
  "independence-ky",
  "hillview-ky",
  "simpsonville-ky",
  "burlington-ky",
  "florence-ky",
  "madison-in",
  "newport-ky",
  "radcliff-ky",
  "salem-in",
  "fort-knox-ky",
  "danville-ky",
  "coxs-creek-ky",
  "owensboro-ky",
]);

export const allLocations: LocationData[] = [

  ...locations,
  ...simpleLocations.map(loc => {
    const detail = cityDetail[loc.slug];
    const tag = detail?.tag ?? `the ${loc.region} region`;
    const landmark = detail?.landmark ?? `the ${loc.city} business district`;
    const focus = detail?.focus ?? "commercial electrical, HVAC, and energy management";
    const expandedDescription = `Licensed electrical and HVAC contractor in ${loc.city}, ${loc.state} — ${tag}. Commercial and residential service. Free estimates.`;
    return {
      ...loc,
      metaTitle: loc.slug === "la-grange-ky" ? "La Grange KY Electrical & HVAC Contractor | (502) 921-3777" : `${loc.city} ${loc.state} Electrical & HVAC Contractor`,
      metaDescription: expandedDescriptionSlugs.has(loc.slug)
        ? (expandedDescription.length <= 155 ? expandedDescription : expandedDescription.replace("residential service.", "residential."))
        : fitDescription(`Hadley Energy serves ${loc.city}, ${loc.state} — ${tag}. ${focus.charAt(0).toUpperCase() + focus.slice(1)}. Free estimates.`),
      content: `Hadley Energy Solutions is the licensed electrical and HVAC contractor businesses trust in ${loc.city}, ${loc.state} — ${tag}. We work near ${landmark}, where local property owners, facility managers, and general contractors rely on our team for ${focus}. With Kentucky license CE64623 and master electrician license ME64500, we've delivered same-day service, free written estimates, and code-compliant installations across the greater ${loc.region} region since 2013. Whether you need a routine service call or a multi-phase capital project in ${loc.city}, our crews show up on time, on budget, and ready to work.`,
      neighbors: neighborMap[loc.slug] || [{ label: "Louisville, KY", href: "/service-area/louisville-ky" }, { label: "Elizabethtown, KY", href: "/service-area/elizabethtown-ky" }],
    };
  }),
];

// Group locations by region for the overview page
export const locationsByRegion = allLocations.reduce((acc, loc) => {
  const region = (loc as any).region || "Kentucky";
  if (!acc[region]) acc[region] = [];
  acc[region].push(loc);
  return acc;
}, {} as Record<string, LocationData[]>);
